const constants = { avireMail: 'hub.support@dewhurst-global.com' }

export default constants
